import React from "react";

import "./DashboardQuizCard.scss";
import CustomButton from "../../../Components/Button/CustomButton";
import { useNavigate } from "react-router-dom";

export default function DashboardQuizCard() {
  const navigate = useNavigate();
  return (
    <div className="custom_card play_quiz_card ">
      <div className="quiz_content">
        <h3>Quiz of the day</h3>
        <p>Compete with your friends in today's quiz</p>
        <div className="start_button_wrapper">
          <CustomButton
            onClick={() => {
              navigate("/qbanks");
            }}
            text="Start Quiz"
            color="primary"
            type="button"
          />
        </div>
      </div>
      <div className="card_image_container">
        <img src="trophy.png" alt="trophy" />
      </div>
    </div>
  );
}
